export default __webpack_public_path__ + "static/mc-tagging.gif-1b7d7303d7cb6b995bcd0ac3d8988de0.mp4";